<app-modal-template
	[iconId]="240"
	[title]="title"
	[showSave]="showSave"
	[disableSave]="disableSave"
	[saveText]="'Save'"
	[saveIcon]="['fass', 'check-circle']"
	[showCancel]="showCancel"
	[cancelText]="'Cancel'"
	[cancelIcon]="['fass', 'arrow-circle-left']"
	[showX]="true"
	(cancelClicked)="cancelClick()"
	(saveClicked)="saveClick()"
>
	<form [formGroup]="formGroup">
		<app-spinner *ngIf="loading"></app-spinner>
		<div *ngIf="!loading">
			<div fxLayout="column" fxLayoutGap="16px">
				<mat-card appearance="outlined" *ngFor="let n of entityNotes; let i = index">
					<div fxLayout="column" fxLayoutGap="16px">
						<div fxLayout="row" fxLayoutGap="16px">
							<!-- Created By Profile Pic -->
							<app-user-profile-pic
								*ngIf="entityNotes[i].createdByEntityNameId == 1"
								[userId]="entityNotes[i].createdBy"
								[appStyle]="{
									height: '32px',
									width: '32px',
									'border-radius': '50%',
									border: 'solid 2px #00acc1'
								}"
								[matTooltip]="'Created By: ' + entityNotes[i].displayName"
								[matTooltipShowDelay]="300"
								[matTooltipHideDelay]="300"
							>
							</app-user-profile-pic>
							<div fxLayout="column">
								<!-- Created Date / Important / History -->
								<div style="margin-bottom: 2px; color: #999; font-size: 9pt; margin-bottom: 4px">
									<!-- Created Date -->
									{{ entityNotes[i].createdDate | moment: 'MM/DD/YYYY hh:mm A' }}

									<!-- Highly Important Icon -->
									<app-db-icon
										class="note-high-importance-icon"
										[iconId]="214"
										*ngIf="entityNotes[i].isHighImportance"
										matTooltip="High Importance"
									></app-db-icon>
								</div>
								<!-- Notes -->
								<div>
									{{
										entityNotes[i].notes?.length <= notePreviewLength ||
										entityNotes[i]?.componentExpanded
											? entityNotes[i].notes
											: entityNotes[i].notes.substring(0, notePreviewLength)
									}}
									<span
										style="color: #999; cursor: pointer; font-size: 9pt"
										*ngIf="
											entityNotes[i].notes?.length > notePreviewLength &&
											!entityNotes[i].componentExpanded
										"
										(click)="toggleExpansion(entityNotes[i])"
									>
										... [more]
									</span>
									<span
										style="color: #999; cursor: pointer; font-size: 9pt"
										*ngIf="
											entityNotes[i].notes?.length > notePreviewLength &&
											entityNotes[i].componentExpanded
										"
										(click)="toggleExpansion(entityNotes[i])"
									>
										[less]
									</span>
								</div>

								<!-- Expiration Date -->
								<div
									style="margin-bottom: 2px; color: #999; font-size: 9pt; margin-top: 4px"
									*ngIf="entityNotes[i].expirationDate"
								>
									Expires On: {{ entityNotes[i].expirationDate | moment: 'MM/DD/YYYY' }}
								</div>
							</div>
						</div>
					</div>
				</mat-card>
			</div>

			<mat-card>
				<div *ngIf="!showNewNote">
					<button
						id="add-note"
						[disabled]="loading"
						mat-button
						class="action-button"
						(click)="addNewNoteClick()"
					>
						<fa-icon [icon]="$any(['fass', 'plus'])"></fa-icon> Add New Note
					</button>
				</div>
				<div *ngIf="showNewNote">
					<!-- Notes Field -->
					<mat-form-field style="width: 100%">
						<mat-label>Add New Note</mat-label>
						<textarea
							#noteInput
							matInput
							maxlength="1000"
							id="new-note-text"
							formControlName="note"
							(change)="notesChangedEvent($event)"
						></textarea>

						<mat-error *ngIf="formGroup.get('note')?.errors?.required">Notes is required</mat-error>
					</mat-form-field>
					<mat-hint>{{ noteInput.value?.length || 0 }}/1000</mat-hint>
					<!-- Expiration Date -->
					<!--<mat-form-field class="full-width">
		<mat-label>Expiration Date</mat-label>
		<input matInput
			   [min]="today"
			   [matDatepicker]="expirationDatePicker"
			   formControlName="expirationDate"
			   autocomplete="off" />
		<mat-datepicker-toggle matSuffix [for]="expirationDatePicker"></mat-datepicker-toggle>
		<mat-datepicker #expirationDatePicker></mat-datepicker>
	</mat-form-field>-->
				</div>
			</mat-card>
		</div>
	</form>
</app-modal-template>
